import {
  QuestionBlank,
  QuestionHotspotChoice,
  QuestionMultipleChoice,
  QuestionOpenField,
  QuestionSlider,
  QuestionWordCloud,
  QuestionMultipleQuestions,
} from "@bd-components/questions";

export const createQuestion = (questionData) => {
  if (questionData.type === "multiple_choice")
    return new QuestionMultipleChoice(questionData);
  else if (questionData.type === "slider")
    return new QuestionSlider(questionData);
  else if (questionData.type === "word_cloud")
    return new QuestionWordCloud(questionData);
  else if (questionData.type === "hotspot_choice")
    return new QuestionHotspotChoice(questionData);
  else if (questionData.type === "open_field")
    return new QuestionOpenField(questionData);
  else if (questionData.type === "multiple_questions")
    return new QuestionMultipleQuestions(questionData);

  return new QuestionBlank(questionData);
};
